import { initEpic } from './state/init.epic';

export const focusSelectorEpics = [initEpic];
